import { API_FACEBOOK_PAGES } from '../../../../utils';
import Swal from 'sweetalert2';

/**
 *
 * @param {*} pageId
 */
export const syncFacebookPage = async (pageId, accessToken) => {
  try {
    await fetch(API_FACEBOOK_PAGES, {
      method: 'POST',
      body: JSON.stringify({ pageId }),
      headers: {
        Authorization: `bearer ${accessToken}`
      }
    });
    Swal.fire({
      icon: 'success',
      title: 'Complete sync with Facebook',
      showConfirmButton: false,
      timer: 3500
    });
  } catch (error) {
    console.error('An error has ocurred', error);
    Swal.fire({
      icon: 'error',
      title: 'Error!',
      text: 'We cannot sync with Facebook'
    });
  }
};
